export const PAYMENTS_REPORT_ID = 'payments';
